import { css } from "styled-components";

export const RequireCSS = css`
  position: relative;
  &::before {
    position: absolute;
    content: "*";
    color: red;
    font-size: 20px;
    left: -2px;
    top: 50%;
    transform: translate(-100%, -30%);
  }
`;

export const RelativeRequireCSS = css`
  position: relative;
  transform: translate(10px, 0);
  &::before {
    position: absolute;
    content: "*";
    color: red;
    font-size: 20px;
    left: -2px;
    top: 50%;
    transform: translate(-100%, -30%);
  }
`;
